var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaqs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 175,
    viewBox: "0 0 233 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2559_111)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 29,
    width: 66,
    height: 5,
    rx: 1,
    fill: "#D1D5DB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 36,
    width: 143,
    height: 5,
    rx: 1,
    fill: "#D1D5DB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 49,
    width: 216,
    height: 95,
    rx: 6,
    fill: "#718095",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 48.5,
    width: 217,
    height: 96,
    rx: 6.5,
    stroke: "#585454",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 60L22.5 62.5M20 65L22.5 62.5M22.5 62.5L20 60M22.5 62.5L25 65",
    stroke: "#3C4148"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 60,
    width: 143,
    height: 5,
    rx: 1,
    fill: "#3C4148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 88V91M23 94V91M23 91H20M23 91H26",
    stroke: "#3C4148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 101V104M23 107V104M23 104H20M23 104H26",
    stroke: "#3C4148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 115V118M23 121V118M23 118H20M23 118H26",
    stroke: "#3C4148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 129V132M23 135V132M23 132H20M23 132H26",
    stroke: "#3C4148"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 88,
    width: 143,
    height: 6,
    rx: 1,
    fill: "#3C4148"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 101,
    width: 143,
    height: 6,
    rx: 1,
    fill: "#3C4148"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 115,
    width: 143,
    height: 6,
    rx: 1,
    fill: "#3C4148"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 129,
    width: 143,
    height: 6,
    rx: 1,
    fill: "#3C4148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 85H218.5",
    stroke: "black",
    strokeOpacity: 0.22,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 98H218.5",
    stroke: "black",
    strokeOpacity: 0.22,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 111H218.5",
    stroke: "black",
    strokeOpacity: 0.22,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 125H218.5",
    stroke: "black",
    strokeOpacity: 0.22,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 68,
    width: 194,
    height: 2,
    rx: 1,
    fill: "#3C4148"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 71,
    width: 192,
    height: 2,
    rx: 1,
    fill: "#3C4148"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 74,
    width: 189,
    height: 2,
    rx: 1,
    fill: "#3C4148"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 77,
    width: 187,
    height: 2,
    rx: 1,
    fill: "#3C4148"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 80,
    width: 184,
    height: 2,
    rx: 1,
    fill: "#3C4148"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2559_111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 233,
    height: 175,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqs);
export default __webpack_public_path__ + "static/media/faqs.3d430bc7c451d7bbbeb7567bb4b33ee4.svg";
export { ForwardRef as ReactComponent };